<template>
     <div class='map_style'>
        <div class="amap_box" ref="amapBox"></div>
        <!-- :style="{height:height}" -->
    </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex';
  import CircleShow from './mark_animation'
  import amapFn from './base_amap_fn'
  import createInfo from './info'
  import mapContent from "./info_window.js";
  export default {
    name: 'goldenMapnamespace',
    props: {
        mapData: {
            type: Object,
            default: function () {
                return {}
            }
        },
        pullData: {
            type: Object,
            default: function () {
                return {}
            }
        },
        change_mapData:{
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data () {
      return {
        amap_map:null,
        pull:{},
        markers:null
      }
    },
    mounted () {
        this.onWindowResize()
        window.addEventListener('resize', this.onWindowResize);
        //this.$nextTick(()=>{
            // this.initBasemap(this.mapData);
            // console.log(this.mapData,'地图数据')
       // });
    },
    computed:{
      ...mapState(['onMessageArrived']),
    },
    watch:{
        mapData:{
            handler:function(newVal,oldVal){
              this.initBasemap(newVal);
            },
            deep:true
        },
        pullData:{
            handler(newVal,oldVal){
                console.log(222222,newVal);
                this.pullMessage(newVal);
            },
            deep:true
        },
        change_mapData:{
             handler(newVal,oldVal){
                //  console.log(newVal,'women')
                // var map_lg_la = [newVal[1],newVal[2],newVal[3]];
                // map_lg_la.forEach((items,index)=>{
                //     items.forEach((item,_index)=>{
                //         if(item.deviceId === newInfo.deviceId){
                //             map_lg_la[index][_index] = this.$deepClone(item);
                //         }
                //     })
                // })
                // this.updateMark(newVal);
            },
            deep:true
        }

    //    onMessageArrived:{
    //         handler(newVal,oldVal){
    //             console.log(newVal,'高德')
    //             var newInfo = typeof newVal == 'string' ? JSON.parse(newVal) : newVal;
    //             this.pullMessage(newInfo);
    //         },
    //         deep:true
    //     }
    },
    methods: {
        //  ...mapMutations(['set_mapData']),
        pullMessage(newInfo){
            console.log(newInfo,'推过来的数据');
            this.$emit('pullMessageEmit',newInfo,this.mapData);
           //处理推过来的数据
             
        //    this.updateMark(this.mapData);
           //处理推过来的数据
            // var map_lg_la = [this.mapData[1],this.mapData[2],this.mapData[3]];
            // map_lg_la.forEach((items,index)=>{
            //     items.forEach((item,_index)=>{
            //         if(item.deviceId === newInfo.deviceId){
            //             map_lg_la[index][_index] = this.$deepClone(this.pull);
            //         }
            //     })
            // })
            // this.updateMark(this.mapData);
        },
        test(){
           this.pull = {
                deviceId: "352425025110274",
                nowState: {mes: "555ppm", valve: "开"},
                position: ["112.476869", "37.837167"],
                realPos: "测试",
                status: 2 ,
            };
            // console.log(333,this.mapData)
            var map_lg_la = [this.mapData[1],this.mapData[2],this.mapData[3]];
            map_lg_la.forEach((items,index)=>{
                items.forEach((item,_index)=>{
                    if(item.deviceId === this.pull.deviceId){
                        map_lg_la[index][_index] = this.$deepClone(this.pull);
                    }
                })
            })
            this.updateMark(this.mapData);
        },
         //页面自适应
        onWindowResize(){
            let pageHeight = document.documentElement.clientHeight; //页面总高度
            if(document.querySelectorAll(".amap_box") && document.querySelectorAll(".amap_box")[0]){
                document.querySelectorAll(".amap_box")[0].style.height =  pageHeight - 260+ 'px';  //在这里可以根据你的边距做调整  
            }
        },
        initBasemap(data){
            this.new_map(data);
            //地图打点
            this.creatMark(data);
            
        },
       
        //只显示中国地图
         new_map() {
             this.amap_map = new AMap.Map(this.$refs.amapBox, {
            // mapStyle: 'amap://styles/c07aae3308abb061ff2a740c3c878d8a', //设置地图的显示样式
            mapStyle: 'amap://styles/0b430c027c7b96a310568a413e275738',
            // mapStyle: 'amap://styles/e7b95a346a74c9bc18e02954ab811737', //设置地图的显示样式
            // center: [112.5358930000,37.8928040000],
            // center: [103.84098053, 38.94489136],
            center:[116.4071700000, 39.9046900000],
            disableSocket: true,
            viewMode: '3D',
            resizeEnable: true,
            buildingAnimation: true, //楼块出现是否带动画,
            expandZoomRange: true,
            features: ['bg', 'road', 'building', 'point'],
            // labelzIndex:130,
            pitch:0,
            zoom: 8,  //地图的大小
    
            });
            
           
        },
      
        /**
         * 创建marker点
         * data：获取的地图数据
         * 
         */
        updateMark(data){
            this.amap_map.clearMap();
            this.creatMark(data);
        },
        creatMark(data){
            console.log("--->>>",data);
            var map_lg_la = [data[1],data[2],data[3]];
            console.log( map_lg_la,'------------????????????')
            var markList =[];
            var vue = this;
            map_lg_la.forEach((item,index)=>{
                item.forEach((i,n)=>{
                    //创建marker点
                     var marker = new AMap.Marker({
                        position : [i.position[0],i.position[1]],
                        // icon:i.status==1?'static/img/green.gif':i.status==0?'static/img/gray.gif':i.status==2?'static/img/red.gif':'',
                        offset : new AMap.Pixel(-21,-21),//偏移量，默认以marker左上角位置为基准点
                        map : vue.amap_map,
                    });
                    // this.markers =  i.marker ;
                    i.marker = marker;
                    // this.amap_map.add(i.marker);  
                    //创建dom
                    createInfo({
                        map: this.amap_map,
                        vue: this,
                        activeIndex: n,
                        data: item,
                    }).then(vue => {
                        i.marker.setContent(vue.$el);
                        vue.$on('domChange', () => {
                            // i.marker.setOffset(new AMap.Pixel(vue.offset[0], vue.offset[1]));
                        });
                        vue.$on('markOver', ()=>{
                            this.mouse_hover(i,index+1);
                        });
                        vue.$on('markOut',()=>{
                            this.mouse_out(i);
                        });
                    });
                })
            })
            // this.amap_map.add(markList);  
            // markers[1].setMap(null);
        },
        /**
         * 鼠标移入事件
         * i是每个mark点得数据
         * type为类型  1.民品 2.工业品 3.工商品
         */
        mouse_hover(i,type){
            var vue = this;
            let content_info = mapContent.createInfoWindow(i, vue.amap_map,type);
            i.marker.content_mouse = new AMap.InfoWindow({
                isCustom: true, //使用自定义窗体
                content: content_info,
                offset: new AMap.Pixel(-8, -30) //-113, -140
            });
            i.marker.content_mouse.open(
                vue.amap_map,
                i.marker.getPosition()
            );
        },
        /**
         * 鼠标移出事件
         * i是每个mark点得数据
         */
        mouse_out(i){
            if ( i.marker.content_mouse) {
                i.marker.content_mouse.close();
            }
            i.marker.content_mouse = null;
        },
    }
  }
</script>
<style lang='less' scoped>
    // .map {
    //     border: 1px solid  rgb(7, 44, 59);
    //     height: 100%;
    //     width:calc(~'100% - '600px);
    //     background: #42bffe;
    // }
    .map_style{
        padding: 0px 30px 0px 30px;
        width: 100%;
        height: 100%;
        .amap_box{
            border: 4px solid #0a3263;
        }
    }
      
</style>

<style>
.amap-info-sharp{
    display: none;
}
.amap-info-content ,.amap-info-outer{
    padding: 0px !important;
}

</style>




// WEBPACK FOOTER //
// src/page/main_content/map/baseMap/base_map_old.vue